package com.milta.feature.admin.data.remote.dto

import com.milta.feature.admin.domain.entity.AdminPrompt
import kotlinx.serialization.Serializable

// Field names match the backend's camelCase JSON exactly — see
// Milta.Application.Admin.Dtos.AdminPromptDto in the milta (backend) repo.

@Serializable
data class AdminPromptDto(
    val key: String,
    val label: String,
    val endpoint: String,
    val body: String,
    val isOverridden: Boolean,
    val contractFooter: String,
    val updatedAt: String?,
    val updatedByAccountId: String?,
)

@Serializable
data class AdminPromptsResponseDto(val prompts: List<AdminPromptDto>)

@Serializable
data class UpdatePromptRequestDto(val body: String)

fun AdminPromptDto.toDomain() = AdminPrompt(
    key = key,
    label = label,
    endpoint = endpoint,
    body = body,
    isOverridden = isOverridden,
    contractFooter = contractFooter,
    updatedAt = updatedAt,
    updatedByAccountId = updatedByAccountId,
)
